import React from 'react';
import Input from '../Input';
import CheckboxGroup from '../CheckboxGroup';

const ProfessionalInfoStep = ({ formData, updateFormData, errors }) => {
  const profissoesOptions = [
    { value: 'pedreiro', label: 'Pedreiro' },
    { value: 'pintor', label: 'Pintor' },
    { value: 'encanador', label: 'Encanador' },
    { value: 'eletricista', label: 'Eletricista' },
    { value: 'azulejista', label: 'Azulejista' },
    { value: 'gesseiro', label: 'Gesseiro' }
  ];

  return (
    <div>
      <h2 className="text-3xl font-semibold text-gray-900 mb-6">
        Informações Profissionais
      </h2>
      
      <div className="space-y-6">
        <CheckboxGroup
          label="Profissões"
          options={profissoesOptions}
          selectedValues={formData.profissoes}
          onChange={(values) => updateFormData('profissoes', values)}
          className="mb-4"
        />

        <div>
          <label className="block text-base font-medium text-gray-700 mb-2">
            Habilidades Específicas
            <span className="text-red-500 ml-1">*</span>
          </label>
          <textarea
            value={formData.habilidades}
            onChange={(e) => updateFormData('habilidades', e.target.value)}
            placeholder="Ex: assentamento de pisos cerâmicos, instalação elétrica residencial, pintura externa com tinta acrílica, reparos hidráulicos em banheiros..."
            rows={4}
            className={`w-full px-4 py-3 border rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-primary-500 transition-colors resize-none ${
              errors.habilidades ? 'border-red-500' : 'border-gray-300'
            }`}
          />
          {errors.habilidades && (
            <p className="text-red-500 text-sm mt-1">{errors.habilidades}</p>
          )}
          <p className="text-sm text-gray-500 mt-1">
            <strong>Importante:</strong> Seja específico e detalhado. Exemplos: "instalação de chuveiros elétricos", "assentamento de azulejos", "pintura de paredes externas". Evite termos genéricos como "trabalho geral" ou "manutenção".
          </p>
        </div>

        <div>
          <label className="block text-base font-medium text-gray-700 mb-2">
            Pretensão de Emprego
          </label>
          <div className="space-y-3">
            <label className="flex items-center">
              <input
                type="radio"
                name="pretensao"
                value="autonomo"
                checked={formData.pretensao === 'autonomo'}
                onChange={(e) => updateFormData('pretensao', e.target.value)}
                className="mr-3 h-4 w-4 text-primary-600 focus:ring-primary-500 border-gray-300"
              />
              <span className="text-gray-700">Autônomo (trabalhar por conta própria)</span>
            </label>
            <label className="flex items-center">
              <input
                type="radio"
                name="pretensao"
                value="empregado"
                checked={formData.pretensao === 'empregado'}
                onChange={(e) => updateFormData('pretensao', e.target.value)}
                className="mr-3 h-4 w-4 text-primary-600 focus:ring-primary-500 border-gray-300"
              />
              <span className="text-gray-700">Empregado (com carteira assinada)</span>
            </label>
            <label className="flex items-center">
              <input
                type="radio"
                name="pretensao"
                value="ambos"
                checked={formData.pretensao === 'ambos'}
                onChange={(e) => updateFormData('pretensao', e.target.value)}
                className="mr-3 h-4 w-4 text-primary-600 focus:ring-primary-500 border-gray-300"
              />
              <span className="text-gray-700">Ambos (autônomo e empregado)</span>
            </label>
          </div>
        </div>

        <div>
          <label className="block text-base font-medium text-gray-700 mb-2">
            Experiência Profissional
            <span className="text-red-500 ml-1">*</span>
          </label>
          <textarea
            value={formData.experiencia}
            onChange={(e) => updateFormData('experiencia', e.target.value)}
            placeholder="Descreva sua experiência profissional, trabalhos realizados, anos de atuação..."
            rows={5}
            className={`w-full px-4 py-3 border rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-primary-500 transition-colors resize-none ${
              errors.experiencia ? 'border-red-500' : 'border-gray-300'
            }`}
          />
          {errors.experiencia && (
            <p className="text-red-500 text-sm mt-1">{errors.experiencia}</p>
          )}
          <p className="text-sm text-gray-500 mt-1">
            Conte-nos sobre sua experiência, trabalhos realizados e tempo de atuação na área
          </p>
        </div>
      </div>
    </div>
  );
};

export default ProfessionalInfoStep;
